const inputAlert = {
  show({
    actions = [],
    onDismiss = null,
    value = "",
    label = "Informar",
    type = null,
  }, delay = 100) {
    setTimeout(() => {
      globalThis.$events.$emit("app-bottom-sheet", {
        actions,
        component: "app-input-alert",
        onDismiss,
        value,
        label,
        type,
      });
    }, delay);
  },

  dismiss() {
    globalThis.$events.$emit("app-bottom-sheet", { dismiss: true });
  },
};

globalThis.$inputAlert = inputAlert;

export default {
  install(Vue) {
    Vue.prototype.$inputAlert = inputAlert;
  },
};
